import * as React from 'react';
import {connect} from 'react-redux';
import Notifications from 'react-notification-system-redux';

const style = {
    Containers: {
        DefaultStyle: {
            maxWidth: '420px',
            width: '100%',
            zIndex: '99'
        },
        bl: {
            left: '240px'
        },
        tc: {
            left: '0',
            maxWidth: '100vw',
            padding: '0',
            top: '60px',
            width: '100vw'
        },
        tr: {
            top: '60px'
        },
        tl: {
            left: '240px',
            top: '60px'
        },
    },
    Dismiss: {
        DefaultStyle: {
            backgroundColor: 'transparent',
            fontWeight: 'normal',
            right: '20px',
            top: '20px'
        }
    },
    NotificationItem: {
        DefaultStyle: {
            borderTop: 'none',
            padding: '0',
            width: '100%',
            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.07)',
            borderRadius: '0',
            height: 'auto'
        },
        error: {
            backgroundColor: '#ff4861'
        },
        info: {
            backgroundColor: '#70bbfd'
        },
        success: {
            backgroundColor: '#4ce1b6'
        },
        warning: {
            backgroundColor: '#f6da6e'
        }
    }
};

interface NotificationProps {
    notifications: any[];
}

const mapStateToProps = (state) => {
    const stateProps = {
        notifications: state.notifications
    };
    return stateProps;
};

class Notification extends React.Component<NotificationProps> {

    public render() {
        const {notifications} = this.props;
        return (
            <Notifications
                notifications={notifications}
                style={style}
            />
        );
    }
}

export default connect(mapStateToProps)(Notification);


// WEBPACK FOOTER //
// ./src/components/common/notification/notification.tsx